import { RefCallback } from "react";

import useSizeObserver from "@app/util/hook/useSizeObserver";

const useDividerSpan = <T extends HTMLElement>(
  threshold: number
): [span: number, ref: RefCallback<null | T>] => {
  const [width, , ref] = useSizeObserver<T>();
  // -1 is needed to guarantee value increment when width === threshold
  const span = Math.ceil(width / (threshold - 1));
  return [span, ref];
};

export default useDividerSpan;
